<template>
    <section class="py-12 bg-gray-50">
        <div class="container mx-auto px-4">
            <!-- Section Title -->
            <h2 class="text-3xl text-green-900 font-bold text-center mb-8">Latest News</h2>

            <!-- Swiper Carousel -->
            <div class="swiper-container mx-auto">
                <div class="swiper-wrapper">
                    <!-- News Item 1 -->
                    <div class="swiper-slide">
                        <div class="bg-white rounded-lg shadow-md overflow-hidden">
                            <img src="https://via.placeholder.com/400x250" alt="News Image"
                                class="w-full h-48 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-semibold mb-2">News Title 1</h3>
                                <p class="text-sm text-gray-500 mb-4">October 10, 2023</p>
                                <a href="#"
                                    class="inline-block px-6 py-2 bg-green-900 text-white rounded-lg hover:bg-blue-700 transition duration-300">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- News Item 2 -->
                    <div class="swiper-slide">
                        <div class="bg-white rounded-lg shadow-md overflow-hidden">
                            <img src="https://via.placeholder.com/400x250" alt="News Image"
                                class="w-full h-48 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-semibold mb-2">News Title 2</h3>
                                <p class="text-sm text-gray-500 mb-4">October 11, 2023</p>
                                <a href="#"
                                    class="inline-block px-6 py-2 bg-green-900 text-white rounded-lg hover:bg-blue-700 transition duration-300">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- News Item 3 -->
                    <div class="swiper-slide">
                        <div class="bg-white rounded-lg shadow-md overflow-hidden">
                            <img src="https://via.placeholder.com/400x250" alt="News Image"
                                class="w-full h-48 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-semibold mb-2">News Title 3</h3>
                                <p class="text-sm text-gray-500 mb-4">October 12, 2023</p>
                                <a href="#"
                                    class="inline-block px-6 py-2 bg-green-900 text-white rounded-lg hover:bg-blue-700 transition duration-300">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- News Item 1 -->
                    <div class="swiper-slide">
                        <div class="bg-white rounded-lg shadow-md overflow-hidden">
                            <img src="https://via.placeholder.com/400x250" alt="News Image"
                                class="w-full h-48 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-semibold mb-2">News Title 1</h3>
                                <p class="text-sm text-gray-500 mb-4">October 10, 2023</p>
                                <a href="#"
                                    class="inline-block px-6 py-2 bg-green-900 text-white rounded-lg hover:bg-blue-700 transition duration-300">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- News Item 2 -->
                    <div class="swiper-slide">
                        <div class="bg-white rounded-lg shadow-md overflow-hidden">
                            <img src="https://via.placeholder.com/400x250" alt="News Image"
                                class="w-full h-48 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-semibold mb-2">News Title 2</h3>
                                <p class="text-sm text-gray-500 mb-4">October 11, 2023</p>
                                <a href="#"
                                    class="inline-block px-6 py-2 bg-green-900 text-white rounded-lg hover:bg-blue-700 transition duration-300">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- News Item 3 -->
                    <div class="swiper-slide">
                        <div class="bg-white rounded-lg shadow-md overflow-hidden">
                            <img src="https://via.placeholder.com/400x250" alt="News Image"
                                class="w-full h-48 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-semibold mb-2">News Title 3</h3>
                                <p class="text-sm text-gray-500 mb-4">October 12, 2023</p>
                                <a href="#"
                                    class="inline-block px-6 py-2 bg-green-900 text-white rounded-lg hover:bg-blue-700 transition duration-300">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Add more news items as needed -->
                </div>

                <!-- Swiper Navigation Buttons -->
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
    </section>
</template>

<script>
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default {
    name: "SectionThree",
    mounted() {
        // Initialize Swiper
        new Swiper(".swiper-container", {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
        });
    },
};
</script>

<style scoped>
/* Custom styles for Swiper */
.swiper-container {
    max-width: 1200px;
    position: relative;
    padding: 0 40px;
    overflow: hidden;
    /* Add padding for navigation buttons */
}

.swiper-button-next,
.swiper-button-prev {
    color: #3b82f6;
    /* Blue color for buttons */
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.swiper-button-next::after,
.swiper-button-prev::after {
    font-size: 20px;
}
</style>